export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref9445.160d895f.jpg";